import { Longhand } from "../longhand.js";
import Base from "./background-repeat-x.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/background-repeat}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=background-repeat-y.js.map